/**
 * Utilitários para geração de ondas SVG (borda superior/inferior)
 */

const buildWaveSvgPath = (type, width, height, balance, complexity, contrast) => {
    const amp = (contrast / 100) * height * 0.45;
    const mid = height * (balance / 100);
    const waves = Math.max(1, Math.round(complexity));
    const pts = 100;
    let path = '';
    for (let i = 0; i <= pts; i++) {
        const x = (i / pts) * width;
        let y;
        if (type === 'sine') {
            y = mid + amp * Math.sin(2 * Math.PI * (x / width) * waves);
        } else if (type === 'square') {
            const phase = ((x / width) * waves) % 1;
            y = phase < 0.5 ? mid - amp : mid + amp;
        } else {
            const phase = ((x / width) * waves) % 1;
            y = mid + amp * (2 * phase - 1);
        }
        path += (i === 0 ? `M ${x} ${y}` : ` L ${x} ${y}`);
    }
    path += ` L ${width} ${height} L 0 ${height} Z`;
    return path;
};

export const getWaveSvgDataUrl = (wc) => {
    if (!wc || !wc.enabled) return null;
    const w = 800;
    const h = Math.max(20, wc.height || 60);
    const path = buildWaveSvgPath(wc.type || 'sine', w, h, wc.balance ?? 50, wc.complexity ?? 3, wc.contrast ?? 50);
    const color = (wc.color || '#0099ff').replace(/"/g, "'");
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${w} ${h}" preserveAspectRatio="none"><path fill="${color}" d="${path}"/></svg>`;
    try {
        const encoded = btoa(unescape(encodeURIComponent(svg)));
        return `url('data:image/svg+xml;base64,${encoded}')`;
    } catch { return null; }
};

export const getWaveSvgInline = (wc) => {
    if (!wc || !wc.enabled) return null;
    const w = 800;
    const h = Math.max(20, wc.height || 60);
    const path = buildWaveSvgPath(wc.type || 'sine', w, h, wc.balance ?? 50, wc.complexity ?? 3, wc.contrast ?? 50);
    const color = (wc.color || '#0099ff').replace(/"/g, '&quot;');
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${w} ${h}" preserveAspectRatio="none" style="width:100%;height:100%;display:block"><path fill="${color}" d="${path}"/></svg>`;
};

export const getWaveHtml = (wc) => {
    if (!wc || !wc.enabled) return '';
    const h = Math.max(20, wc.height || 60);
    const isTop = wc.direction === 'top';
    const svg = getWaveSvgInline(wc);
    if (!svg) return '';
    const style = `position:absolute;left:0;right:0;width:100%;height:${h}px;${isTop ? 'top:0' : 'bottom:0'};z-index:0;overflow:hidden;pointer-events:none`;
    const transform = isTop ? 'scaleY(-1)' : 'none';
    return `<div class="madri-row-wave" style="${style}"><div style="width:100%;height:100%;transform:${transform}">${svg}</div></div>`;
};
